import react from 'react';
import { FaFacebook,FaPhone,FaEnvelope } from 'react-icons/fa';
function Footer(){
    
    return(
        <>
            <footer className='bg-[var(--header)] m-5 font-ibmArabic' dir='rtl'
                style={{
                background: "linear-gradient(135deg, #F0FFFF 0%, #E0F7FF 35%, #B3E9FF 70%, #7FD4FF 100%)", 
                margin: '0px',
            }}
            >
                <p className='font-extrabold text-3xl  mr-4'>تواصل معنا</p> <br/>
                <div className='font-bold font-ibmArabic flex items-center gap-2 mr-5' >
                    <FaPhone className='' />
                    <p className=''> 0913009604 || 0924359604 218+</p>
                </div>
                <br/>
                <div className='flex items-center gap-2  mr-5'>
                    <a href='https://www.facebook.com/Maralibya.ly' target='noreferrer'><FaFacebook className='text-2xl'/></a>
                    <FaEnvelope className='text-2xl'/>
                    <p className='font-bold text-xl'>info@mara.ly</p>
                </div>
            </footer>
        </>
    )
}
export default Footer;